var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{staticClass:"main",attrs:{"src":require('@/assets/bg.png')}}),_vm._m(0),(_vm.show.showLoading)?_c('div',{attrs:{"id":"loading"}},[_c('div',{staticClass:"content"},[_c('v-icon',{attrs:{"name":"spinner","pulse":"","scale":"3"}})],1)]):_vm._e(),_c('div',{staticClass:"container-fluid d-flex justify-content-center"},[_c('div',{staticClass:"col col-md-6 col-sm-6 pt-3"},[_c('div',{staticClass:"input-group mb-2"},[_c('b-input-group-prepend',{attrs:{"is-text":""}},[_c('b-icon',{attrs:{"icon":"search"}})],1),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.init.search),expression:"init.search"}],staticClass:"form-control",attrs:{"type":"text","placeholder":"Enter your valid Transaction hash or valid Wallet Address"},domProps:{"value":(_vm.init.search)},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.search.apply(null, arguments)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.init, "search", $event.target.value)}}})],1)])]),_c('Particles',{attrs:{"id":"tsparticles","particlesInit":_vm.particlesInit,"particlesLoaded":_vm.particlesLoaded,"options":{
       background: {
           color: {
               
           }
       },
       fpsLimit: 120,
       interactivity: {
           events: {
               onClick: {
                   enable: true,
                   mode: 'push'
               },
               onHover: {
                   enable: true,
                   mode: 'repulse'
               },
               resize: true
           },
           modes: {
               bubble: {
                   distance: 400,
                   duration: 1,
                   opacity: 0.8,
                   size: 40
               },
               push: {
                   quantity: 4
               },
               repulse: {
                   distance: 200,
                   duration: 1
               }
           }
       },
       particles: {
           color: {
               value: '#ffffff'
           },
           links: {
               color: '#ffffff',
               distance: 150,
               enable: true,
               opacity: 0.5,
               width: 1
           },
           collisions: {
               enable: true
           },
           move: {
               direction: 'none',
               enable: true,
               outMode: 'bounce',
               random: false,
               speed: 1,
               straight: false
           },
           number: {
               density: {
                   enable: true,
                   area: 800
               },
               value: 80
           },
           opacity: {
               value: 0.5
           },
           shape: {
               type: 'circle'
           },
           size: {
               random: true,
               value: 5
           }
       },
       detectRetina: true
   }}}),_c('div',{staticClass:"bg2 no-gutter container"},[_c('div',{staticClass:"table-responsive row main-content container"},[_c('table',{staticClass:"text"},[_c('tr',[_c('td',[_vm._v("Hash")]),_c('td',[_vm._v(_vm._s(this.$route.params.txnHash))])]),_c('tr',[_c('td',[_vm._v("Address")]),_c('td',[_vm._v(_vm._s(_vm.miner))])]),_c('tr',[_c('td',[_vm._v("Amount")]),_c('td',[_vm._v(_vm._s(_vm.formatAmount(_vm.reward)))])]),_c('tr',[_c('td',[_vm._v("Status")]),_c('td',[_vm._v(_vm._s(_vm.status))])]),_c('tr',[_c('td',[_vm._v("Confirmations")]),_c('td',[_vm._v(_vm._s(_vm.confirmations))])])])])]),_c('div',{staticClass:"pt-5 row main-content"},[_c('h4',{staticClass:"text-white"},[_vm._v("Block Transactions")]),_c('div',{staticClass:"table-responsive container-fluid row"},[_c('table',{attrs:{"id":"blocks"}},[_vm._m(1),_c('tbody',[_c('tr',[_c('td',{attrs:{"id":"hash"}},[_vm._v(_vm._s(_vm.init.txnDetails.hash))]),_c('td',[_vm._v(_vm._s(_vm.formatDate(_vm.init.txnDetails.input.timeStamp)))]),_c('td',[_vm._v(_vm._s(_vm.formatAmount(_vm.init.txnDetails.amount)))]),_c('td',[_vm._v(_vm._s(_vm.init.txnDetails.symbol))]),_c('td',[_vm._v(_vm._s(_vm.init.txnDetails.input.address != null ? _vm.init.txnDetails.input.address : "BLX Genesis Asset")+" ")]),_c('td',[_vm._v(_vm._s(_vm.init.txnDetails.recipient))])])])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid row pt-3"},[_c('nav',{staticClass:"container mx-auto navbar navbar-expand-lg navbar-dark nav-dark pt-5"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"/"}},[_c('img',{attrs:{"src":require("@/assets/logo.png")}})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('th',[_vm._v("Hash")]),_c('th',[_vm._v("Timestamp")]),_c('th',[_vm._v("Amount")]),_c('th',[_vm._v("Symbol")]),_c('th',[_vm._v("Input")]),_c('th',[_vm._v("Output")])])}]

export { render, staticRenderFns }